// extracted by mini-css-extract-plugin
export var dataCell = "_nl-2";
export var dataRow = "_nl-0";
export var headerRow = "_nl-1";